import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'cipx-select',
  templateUrl: './cipx-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule
  ],
})
export class CipxSelectComponent {
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() placeholder = '';
  @Input() options: any[] = [];
  @Input() valueKey = 'id';
  @Input() labelKey = 'label';
  @Input() required = false;
  @Input() appearance: 'fill' | 'outline' = 'fill';
  @Input() containerClass = 'my-4 -mb-6';
  @Input() noLabel = false;
  @Input() multiple = false;

  @Output() selectionChange = new EventEmitter<MatSelectChange>();
}
